import * as types from "./types";
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
import { set } from 'lodash';
export const distributionSupplierOrderMutations = {
    [types.DistributionSupplierOrderList.SET.ALL](state, payload) {
        state.distributionSupplierOrderList = payload;
        // if(state.distributionOrderList.order_types){
        //   state.distributionOrderList.orders=state.distributionOrderList.orders.map(e=>{
        //     const order_type_name =state.distributionOrderList.order_types.find(x=>x.value==e.order_type);
        //     if(order_type_name){
        //       return{
        //         ...e,
        //         order_type_name:order_type_name.label
        //       }
        //     }
        //     else{
        //       return{
        //         ...e,
        //         order_type_name:''
        //       }
        //     } 
    
        //   })
        // }
    },

    [types.DistributionSupplierOrderList.DELETE.SINGLE](state, payload) {
      let list = state.distributionSupplierOrderList?.supplier_orders;
      list = list.filter(e => e.supplier_order_id !== payload)
      state.distributionSupplierOrderList = {
        ...state.distributionSupplierOrderList,
        supplier_orders: [
          ...list
        ]
      }
    },

    ...implementSetAllNavTabDetailsMutation(types.DistributionSupplierOrderDetails, 'distributionSupplierOrderDetails'),
}